import { ButtonsOptionsInterface } from '../../../interfaces/dto/buttons/buttons-options-interface';
import { ExtraButtonsModel } from '@fh-client-interaction-frontends/fh-providers';

export class ButtonsOptionsModel implements ButtonsOptionsInterface {
  add: boolean = false;
  cancel: boolean = false;
  delete: boolean = false;
  edit: boolean = false;
  extraBtns: ExtraButtonsModel[] = new Array<ExtraButtonsModel>();
  save: boolean = false;
}
